/**
 * Auto-derive API URL from ENVIRONMENT variable
 * Supports: 'local', 'dev', 'staging', 'prod'
 */
type Environment = 'local' | 'dev' | 'staging' | 'prod'

const API_URL_MAP: Record<Environment, string> = {
    local: 'http://localhost:8000',
    dev: 'https://dev.cgmdashboard.com',           // Use CloudFront (routes /api/* to ALB)
    staging: 'https://staging.cgmdashboard.com',   // Use CloudFront (routes /api/* to ALB)
    prod: 'https://app.cgmdashboard.com'           // Use CloudFront (routes /api/* to ALB)
}

// Get environment from VITE_ENVIRONMENT, fallback to 'local'
const ENVIRONMENT = (import.meta.env.VITE_ENVIRONMENT || 'local') as Environment

// Allow VITE_API_BASE_URL to override for backward compatibility and testing
export const API_BASE_URL = 
    import.meta.env.VITE_API_BASE_URL ||
    API_URL_MAP[ENVIRONMENT] || 
    API_URL_MAP.local

// Debug logging to help troubleshoot
console.log('API Configuration Debug:')
console.log('- VITE_ENVIRONMENT:', import.meta.env.VITE_ENVIRONMENT)
console.log('- Resolved ENVIRONMENT:', ENVIRONMENT)
console.log('- VITE_API_BASE_URL (override):', import.meta.env.VITE_API_BASE_URL)
console.log('- Final API_BASE_URL:', API_BASE_URL)

export const getApiUrl = (endpoint: string): string => {
    // In development with Vite proxy, check if we're running on the dev server with localhost backend
    const isDevelopment = import.meta.env.DEV
    const isViteDevServer = isDevelopment && window.location.port === '5173'
    const isUsingLocalBackend = API_BASE_URL.includes('localhost') || API_BASE_URL.includes('127.0.0.1')
    
    // If running on Vite dev server with local backend, use proxy
    if (isViteDevServer && isUsingLocalBackend) {
        console.log(`getApiUrl: Using proxy for ${endpoint}`)
        return endpoint
    }
    
    // Otherwise, construct full URL with base URL
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
    const fullUrl = `${API_BASE_URL}/${cleanEndpoint}`
    console.log(`getApiUrl: ${endpoint} -> ${fullUrl}`)
    return fullUrl
} 